
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class AttemptsDialog extends Serenity.EntityDialog<AttemptsRow, any> {
        protected getFormKey() { return AttemptsForm.formKey; }
        protected getIdProperty() { return AttemptsRow.idProperty; }
        protected getLocalTextPrefix() { return AttemptsRow.localTextPrefix; }
        protected getNameProperty() { return AttemptsRow.nameProperty; }
        protected getService() { return AttemptsService.baseUrl; }
        protected getDeletePermission() { return AttemptsRow.deletePermission; }
        protected getInsertPermission() { return AttemptsRow.insertPermission; }
        protected getUpdatePermission() { return AttemptsRow.updatePermission; }

        protected form = new AttemptsForm(this.idPrefix);

    }
}